jQuery(document).foundation();